import { faHandPointRight, faPlayCircle, faSignal } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Zoom } from 'react-reveal';
import { Link } from 'react-router-dom';


const LiveCourseCart = ({ course }) => {
    const { courseThubnail, courseTitle, _id, live, revision, test } = course;

    return (
        <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg rounded" style={{ minHeight: '420px' }}>
                    <img src={courseThubnail} alt={courseTitle} className='img-fluid mb-1 d-block mx-auto w-100 rounded' style={{ height: '200px' }} />
                    <div className="live-title mt-3">
                        <h5 className='mb-2 text-center fw-bold text-dark fs-4'>{courseTitle}</h5>
                        <hr />
                    </div>
                    <div className="live-title ps-3 pe-3">
                        <p className='mt-1 fs-5'><FontAwesomeIcon icon={faSignal} className='me-2' />{`${live} টি লাইভ ক্লাস, সাথে আছে মডেল টেস্ট ${test} টি `}</p>
                        <p className='mt-2 fs-5'><FontAwesomeIcon icon={faPlayCircle} className='me-2' />ক্লাস: {revision} টি CQ + MCQ রেকর্ডেড লাইভ ক্লাস</p>
                    </div>
                    <hr />
                    <Link to={`/freePaidCourseDetails/${_id}`}>
                        <button className="btn text-success fw-bold text-center d-block mx-auto fs-4">ভর্তি হও <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
                    </Link>

                </div>
            </Zoom>
        </div>
    );
};

export default LiveCourseCart;